import {Ticket} from "./ticket";
export class Order {

   public id:any;
   public date:any;
   public state:any;
   public total_price:any;
   public user_id:any;
   public event_id:any;
   public tickets:Ticket[];
   public payment:any;
   public ca:any;
   public cAkces:any;
   public nbParticipant;
   public smart_urlID;
   public isRegistration:boolean = false;
   public Buyerinputs:any=[];
   public codepromos:any=[];
   public donation_receipt:boolean = false;
   public options:any =[];

  constructor() {}

}
